( function ( _s ) {
	/**
	 * from: https://stackoverflow.com/questions/10787782/full-height-of-a-html-element-div-including-border-padding-and-margin
	 * @param {*} el
	 * @return
	 */
	const getAbsoluteHeight = el => {
		const styles = window.getComputedStyle( el );
		const margin = parseFloat( styles.marginTop ) + parseFloat( styles.marginBottom );
		return Math.ceil( el.offsetHeight + margin );
	};

	/**
	 * Loads the shave library asyncly and calls the indicated callback, if
	 * the library is already loaded (object exists on window) then we just execute the callback
	 *
	 * @param {Function} callback
	 */
	const loadShaveLib = callback => {
		if ( typeof window.shave === 'function' ) {
			callback();
		} else {
			window
				.fetchInject( [
					'https://cdnjs.cloudflare.com/ajax/libs/shave/5.0.4/shave.min.js',
				] )
				.then( () => {
					callback();
				} );
		}
	};

	const initializeTruncationEv = _textWrap => {
		const _title = _textWrap.find( ':scope > h5' );
		const _desc = _textWrap.find( ':scope > p' );
		const originalTitle = _title.length ? _title.el[ 0 ].textContent : '';
		const originalDesc = _desc.length ? _desc.el[ 0 ].textContent : '';

		//window event when resized
		_s( window ).on(
			'resize',
			window.debounce( () => {
				//set original text
				if ( _title.length ) {
					_title.el[ 0 ].textContent = originalTitle;
				}
				if ( _desc.length ) {
					_desc.el[ 0 ].textContent = originalDesc;
				}
				//then do truncate again
				truncateText( _title, _desc, _textWrap );
			}, 300 )
		);

		//truncate on page load
		truncateText( _title, _desc, _textWrap );
	};

	/**
	 *
	 * @param {*} _title
	 * @param {*} _desc
	 * @param {*} _textWrap
	 *
	 *                      checks if the wrapper's height is shorter than the sum of title + desc then we
	 *                      need to truncate text.
	 *
	 *                      we truncate the title to up to 7 lines. If title is shorter then we calculate the
	 *                      remaining space for the descrition and we truncate the text based off the avail space.
	 */
	const truncateText = ( _title, _desc, _textWrap ) => {
		const textWrapHeight = _textWrap.height();
		const titleHeight = _title.length ? getAbsoluteHeight( _title.el[ 0 ] ) : 0;
		const descHeight = _desc.length ? getAbsoluteHeight( _desc.el[ 0 ] ) : 0;
		const dateHeight = _textWrap.find( 'span.date' ).length
			? getAbsoluteHeight( _textWrap.find( 'span.date' ).el[ 0 ] )
			: 0;

		if ( titleHeight + descHeight + dateHeight > parseFloat( _textWrap.css( 'max-height' ) ) ) {
			if ( titleHeight > textWrapHeight ) {
				window.shave( _title.el[ 0 ], textWrapHeight );
				window.shave( _desc.el[ 0 ], 0 );
			} else {
				// If it has a date element we need to substract that too
				window.shave( _desc.el[ 0 ], textWrapHeight - titleHeight - dateHeight );
			}
		}
	};

	_s.fn.cardInit = function () {
		return this.each( el => {
			const _self = _s( el );
			const _textWrap = _self.find( '.text-wrapper' );
			if ( ! _self.hasClass( 'is--initialized' ) ) {
				initializeTruncationEv( _textWrap );
				_self.addClass( 'is--initialized' );
			}
		} );
	};

	/* When we call the event, we load the shave library and then trigger the callback indicated */
	_s( window ).on( 'fr:initialize-shave', e => {
		loadShaveLib( e.detail.callback );
	} );

	_s( document ).ready( () => {
		const _els = _s( '.card' );

		if ( _els.el.length ) {
			_s( window ).trigger( 'fr:initialize-shave', {
				callback: () => {
					_els.cardInit();
				},
			} );
		}
	} );
} )( window._s );
